var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessDealHandshakeCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "business-deal-handshake-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18.7499 14.0039L13.9629 14.9609",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M14.438 9.53106L12.178 10.4861C11.8176 10.635 11.4119 10.6292 11.056 10.4701C10.6952 10.3089 10.4139 10.01 10.275 9.64006C9.99448 8.91933 10.2979 8.10275 10.981 7.74006L13.24 6.61306C13.7339 6.35703 14.3134 6.32285 14.834 6.51906L19.473 8.34706",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M5.2002 15H6.8002L9.8492 17.326C10.1456 17.661 10.6542 17.7008 10.9992 17.416L15.2592 13.898C15.6092 13.6083 15.6663 13.0933 15.3882 12.734L13.0412 10.125",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M10.7363 7.90007L10.4893 7.70007C9.99138 7.33271 9.33882 7.24911 8.76434 7.47907L5.19434 9.00007",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    d: "M1.38965 15.7502H4.04965C4.67641 15.7837 5.21259 15.3048 5.24965 14.6782V9.3212C5.21206 8.69503 4.67605 8.21663 4.04965 8.2502H1.38965",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    d: "M22.61 15.7502H19.95C19.3232 15.7837 18.7871 15.3048 18.75 14.6782V9.3212C18.7876 8.69503 19.3236 8.21663 19.95 8.2502H22.61",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessDealHandshakeCircleIcon);
export default __webpack_public_path__ + "static/media/businessDealHandshakeCircleIcon.c27e7769b3cc74779ee8390d1600613c.svg";
export { ForwardRef as ReactComponent };